module.exports = "/subscriptions/assets/e8cdb69ddb2a0da0f2bdd9ebf9bbd005.png";